import PropTypes from 'prop-types';

var propTypes = {
    isOpen: PropTypes.bool,
    variant: PropTypes.string,
    showArrow: PropTypes.bool,
    className: PropTypes.string,
    portalTarget: PropTypes.oneOfType([
        PropTypes.instanceOf(Element),
        PropTypes.node,
    ]),
    'data-testid': PropTypes.string,
    trigger: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
};
var defaultProps = {
    isOpen: false,
    variant: 'bottom',
    showArrow: false,
    'data-testid': 'popover',
};
/** Transform variant prop for Popper "placement' equivalent for backwards compatibility
 *  https://popper.js.org/docs/v1/#Popper.placements
 */
var VARIANT_MAP = {
    top: 'top',
    topLeft: 'top-start',
    topRight: 'top-end',
    right: 'right',
    rightTop: 'right-start',
    rightBottom: 'right-end',
    bottom: 'bottom',
    bottomLeft: 'bottom-start',
    bottomRight: 'bottom-end',
    left: 'left',
    leftTop: 'left-start',
    leftBottom: 'left-end',
};
var DEFAULT_MODIFIERS = [
    { name: 'hide', enabled: false },
    { name: 'preventOverflow', enabled: false },
    { name: 'flip', enabled: false },
    { name: 'arrow', enabled: false },
];

export { DEFAULT_MODIFIERS, VARIANT_MAP, defaultProps, propTypes };
